import React from 'react';
import { Box, Container } from '@mui/material';
import HeroBanner from '../../components/home/hero-banner';
import { useHomeState } from '../context/home-context';

// Hero na mesma largura do corpo do site (container), com respiro abaixo da navegação
export default function SectionBanner() {
  const { banners } = useHomeState();

  if (!banners?.length) return null;

  return (
    <Box component="section" aria-label="Destaques" sx={{ py: { xs: 2, md: 3 } }}>
      <Container maxWidth="xl">
        <HeroBanner banners={banners} />
      </Container>
    </Box>
  );
}
